// Generated by AI on 06/29/2026
import React, {
    useState,
    useCallback,
    useMemo,
} from 'react';
import PropTypes from 'prop-types';

const CampaignEventsContext = React.createContext({
    refreshCampaignTrigger: 0,
    triggerCampaignRefresh: () => {},
    isCampaignChangesValid: true,
    setIsCampaignChangesValid: () => {},
});

export const AppWithCampaignEvents = ({ children }) => {
    const [refreshCampaignTrigger, setRefreshCampaignTrigger] = useState(0);
    const [isCampaignChangesValid, setIsCampaignChangesValid] = useState(true);

    const triggerCampaignRefresh = useCallback(() => {
        setRefreshCampaignTrigger((prev) => prev + 1);
    }, []);

    const contextValue = useMemo(() => ({
        refreshCampaignTrigger,
        triggerCampaignRefresh,
        isCampaignChangesValid,
        setIsCampaignChangesValid,
    }), [
        refreshCampaignTrigger,
        triggerCampaignRefresh,
        isCampaignChangesValid,
        setIsCampaignChangesValid,
    ]);

    return (
        <CampaignEventsContext.Provider value={contextValue}>
            {children}
        </CampaignEventsContext.Provider>
    );
};

AppWithCampaignEvents.propTypes = {
    children: PropTypes.node.isRequired,
};

export default CampaignEventsContext;
